import React from "react"
import SchemaCreate from "@/components/SchemaCreate"

export default function SchemaCreateView() {
  return <SchemaCreate />
}
